import { render, staticRenderFns } from "./PersonQuery.vue?vue&type=template&id=1ee9395c&scoped=true"
import script from "./PersonQuery.vue?vue&type=script&lang=js"
export * from "./PersonQuery.vue?vue&type=script&lang=js"
import style0 from "./PersonQuery.vue?vue&type=style&index=0&id=1ee9395c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee9395c",
  null
  
)

export default component.exports